<template>
  <div>
  </div>
</template>

<script>
export default {
  name: "OnlineSessionSetting",
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped>

</style>